import bodybuilder from 'bodybuilder'
import * as Redux from 'redux'
import * as Elasticsearch from '../../elasticsearch'
import * as Request from '../../request'
import {ApplicationState} from '../../rootReducer'
import * as Constants from './constants'
import * as Types from './types'

export const fetchEmailActions = (state: ApplicationState) =>
  Elasticsearch.createEsSearch(Constants.FETCH_HOME_REPORT_EMAIL_ACTIONS)(
    state.app.selectedCommunity,
    Elasticsearch.Indexes.EmailActions,
    bodybuilder()
      .size(0)
      .filter(
        'term',
        Elasticsearch.keyword(Elasticsearch.DocumentFieldNames.Community),
        state.app.selectedCommunity)
      .filter(
        'term',
        Elasticsearch.DocumentFieldNames.IncludeInReports,
        true)
      .filter(
        'term',
        Elasticsearch.keyword(Elasticsearch.DocumentFieldNames.MessageType),
        Elasticsearch.NEWSBRIEF_MESSAGE)
      .query(
        'range',
        Elasticsearch.DocumentFieldNames.MessageSendDate,
        {
          gte: 'now-1M/w',
          lt: 'now/w',
        },
      ).aggregation(
        'terms',
        Elasticsearch.keyword(Elasticsearch.DocumentFieldNames.EventName),
        Elasticsearch.AggFieldNames.Engagement,
        (a: any) => a.aggregation(
          'date_histogram',
          Elasticsearch.DocumentFieldNames.MessageSendDate,
          { interval: Elasticsearch.Intervals.Week },
          Elasticsearch.AggFieldNames.TotalCount,
          (subAgg: any) => subAgg.aggregation(
            'cardinality',
            Elasticsearch.DocumentFieldNames.CommunityPersonId,
            Elasticsearch.AggFieldNames.UniqueCount,
          ),
        ),
      ).aggregation(
        'terms',
        Elasticsearch.keyword(Elasticsearch.DocumentFieldNames.Name),
        Elasticsearch.AggFieldNames.TopSourceClicks,
        {size: 10},
      ).build())

export const fetchTags = (state: ApplicationState) =>
  Elasticsearch.createEsSearch(Constants.FETCH_HOME_REPORT_TAGS)(
    state.app.selectedCommunity,
    'tags',
    bodybuilder()
      .size(0)
      .filter('term', Elasticsearch.keyword(Elasticsearch.DocumentFieldNames.Community), state.app.selectedCommunity)
      .query(
        'range',
        Elasticsearch.DocumentFieldNames.MessageSendDate,
        {
          gte: 'now-1M/w',
          lt: 'now/w',
        },
      ).aggregation(
        'terms',
        Elasticsearch.keyword(Elasticsearch.DocumentFieldNames.Text),
        Elasticsearch.AggFieldNames.TopTerms,
        {size: 30},
      ).build())

export type Options = Request.RequestOptions<null, Types.FetchTotalMembersParams>
export type FetchMembersAction = Request.RequestAction<Request.RequestOptions>
export type FetchTotalMembers = Redux.ActionCreator<FetchMembersAction>
export const fetchTotalMembers: FetchTotalMembers = (state: ApplicationState) =>
  Request.requestActionCreator(Constants.FETCH_ACTIVE_MEMBERS)
  ({
    method: 'GET',
    url: `${Constants.SERVER_RESOURCE}/${state.app.selectedCommunity}`,
  })



// WEBPACK FOOTER //
// ./src/pages/home/actions.ts